import React, {useEffect, useState} from 'react';
import {Search} from 'react-feather';
import {from, BehaviorSubject} from 'rxjs';
import {
    filter,
    debounceTime,
    distinctUntilChanged,
    switchMap,
} from 'rxjs/operators';
import LoadSpinner from "../Common/LoadSpinner";
import {getAdminFilterBrokers} from "../../services/api/admin";

let searchSubject = new BehaviorSubject('');

let adminSearchResultObservable = searchSubject.pipe(
    filter((val) => val.length > 2),
    debounceTime(1250),
    distinctUntilChanged(),
    switchMap((val) => from(getAdminFilterBrokers(val))),
);


const useObservable = (observable, setter, setterLoad) => {
    useEffect(() => {
        let subscription = observable.subscribe((results) => {
            setter(results);
            setterLoad(false);
        });

        return () => subscription.unsubscribe();
    }, [observable, setter, setterLoad]);
};

const BrokerSearch = ({onBrokerSelect, hasError = false}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResultBrokers, setSearchResultBrokers] = useState([]);
    const [loading, setLoading] = useState(false);

    useObservable(adminSearchResultObservable, setSearchResultBrokers, setLoading);

    useEffect(() => {
        return () => {
            searchSubject.next('');
        };
    }, [searchTerm]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        setLoading(value.length > 2);
        setSearchResultBrokers([]);
        searchSubject.next(value);
    };

    const brokerSelect = (broker) => {
        onBrokerSelect(broker);

        setSearchTerm('');
        setSearchResultBrokers([]);
        setLoading(false);
    };

    return (
        <div className="sl-flex sl-flex-col sl-gap-2 sl-align-stretch">
            <div
                className={`sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex
                ${hasError ? 'sl-border-1 sl-border-solid sl-border-error-300 ' : ''}`}>
                <Search className="sl-icon sl-icon-leading sl-place-self-center sl-h-5 sl-w-5 sl-ml-2"/>
                <input
                    value={searchTerm}
                    onChange={handleInputChange}
                    className="sl-input sl-border-none sl-font sl-text-md sl-font sl-font-normal sl-text-md sl-p-0 sl-m-0 sl-h-11 sl-w-fill-available"
                    type="text"
                    placeholder="Search"
                />
            </div>

            {searchResultBrokers?.length > 0 &&
                <div
                    className="sl-flex sl-shadow-lg sl-rounded-lg sl-flex-col sl-gap-0 sl-mb-6 sl-text-gray-900 sl-text-md sl-h-auto sl-max-h-80 sl-overflow-y-scroll sl-customized-scrollbar">
                    {searchResultBrokers.map((broker, index) => (
                        <div
                            key={index}
                            rel={broker.id}
                            className="sl-cursor-pointer sl-flex sl-justify-flex-start sl-align-center sl-gap-2 sl-py-10 sl-px-14"
                            onClick={() => brokerSelect(broker)}
                        >
                            {broker.name}
                        </div>
                    ))}
            </div>}

            {searchResultBrokers?.length === 0 &&
                <div
                    className="sl-flex sl-shadow-lg sl-rounded-lg sl-flex-col sl-gap-0 sl-text-gray-900 sl-text-md sl-h-auto sl-max-h-80 sl-overflow-y-scroll sl-customized-scrollbar">
                    {(searchResultBrokers.length === 0 && searchTerm.length > 2) && !loading &&
                    <div
                        className="sl-cursor-pointer sl-flex sl-justify-flex-start sl-align-center sl-gap-2 sl-py-10 sl-px-14">
                        Nothing found...
                    </div>}
        </div>}

{
    loading && <LoadSpinner/>
}
</div>
)
    ;
};

export default BrokerSearch;
